// Notifications in-app : remplace les popups OS du navigateur.
// Affiche un toast enrichi (avatar + titre + aperçu + action) dans le coin
// supérieur droit, auto-dismiss 5 s, stackable.

let _container = null;

function _getContainer() {
    if (_container) return _container;
    _container = document.createElement('div');
    _container.id = 'inapp-notif-container';
    document.body.appendChild(_container);
    return _container;
}

export function notifInApp({ titre, texte, avatarUrl, couleur, onClick } = {}) {
    if (document.hasFocus() === false) {
        // Quand la fenêtre n'est vraiment pas visible, on garde aussi la notif OS
        _notifOS(titre, texte, onClick);
    }

    const container = _getContainer();
    const el = document.createElement('div');
    el.className = 'inapp-notif';

    // Avatar
    const av = document.createElement('div');
    av.className = 'ian-avatar';
    if (avatarUrl && avatarUrl !== 'none') {
        av.style.backgroundImage = `url('${avatarUrl}')`;
        av.style.backgroundSize  = 'cover';
    } else {
        av.style.background = couleur || '#58a6ff';
        av.textContent = (titre || '?').charAt(0).toUpperCase();
    }

    const body = document.createElement('div');
    body.className = 'ian-body';

    const t = document.createElement('div');
    t.className = 'ian-titre';
    t.textContent = titre || '';

    const p = document.createElement('div');
    p.className = 'ian-texte';
    p.textContent = _apercu(texte || '');

    body.appendChild(t);
    body.appendChild(p);

    const close = document.createElement('button');
    close.className = 'ian-close';
    close.textContent = '✕';
    close.onclick = (e) => { e.stopPropagation(); _dismiss(el); };

    el.appendChild(av);
    el.appendChild(body);
    el.appendChild(close);

    if (typeof onClick === 'function') {
        el.style.cursor = 'pointer';
        el.onclick = () => { onClick(); _dismiss(el); };
    }

    container.appendChild(el);
    // force reflow pour l'animation d'entrée
    void el.offsetWidth;
    el.classList.add('ian-visible');

    const timer = setTimeout(() => _dismiss(el), 5000);
    el._dismissTimer = timer;

    // Pause du timer au survol
    el.addEventListener('mouseenter', () => clearTimeout(el._dismissTimer));
    el.addEventListener('mouseleave', () => {
        el._dismissTimer = setTimeout(() => _dismiss(el), 2500);
    });
}

function _dismiss(el) {
    clearTimeout(el._dismissTimer);
    el.classList.remove('ian-visible');
    el.classList.add('ian-out');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
}

function _apercu(texte) {
    // Retire les balises Markdown basiques et tronque
    const propre = texte.replace(/[*_`~]/g, '').replace(/\n/g, ' ').trim();
    return propre.length > 80 ? propre.slice(0, 80) + '…' : propre;
}

function _notifOS(titre, texte, onClick) {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    try {
        const n = new Notification(titre, { body: _apercu(texte), tag: 'chaos-' + titre, renotify: false });
        n.onclick = () => {
            try { window.chaosNative?.focusWindow?.(); } catch (_) {}
            try { window.focus(); } catch (_) {}
            try { if (typeof onClick === 'function') onClick(); } catch (_) {}
            n.close();
        };
    } catch (_) {}
}
